import { TaxBreakdownResponse, TaxDetailResponse } from "../../model/CfdisNonIntegrated";

export type TaxBreakdownType = 'transfers' | 'withholdings';
export type TaxBreakdownContext = 'general' | 'unregistered' | 'issuer';

export interface TaxBreakdownModalProps {
  open: boolean;
  type: TaxBreakdownType;
  context: TaxBreakdownContext;
  data?: TaxBreakdownResponse;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  issuerName?: string;
  onClose: () => void;
}

export interface ProcessedTaxItem {
  tax_type: string;
  tax_code: string;
  rate?: number;
  has_rate: boolean;
  invoice_count: number;
  amount: number;
  currency: string;
  status: 'PENDING_LOADING' | 'CANCELLATION_REQUESTED';
}

export interface ProcessedTaxData {
  currency: string;
  currency_name: string;
  total_pending: number;
  total_cancellation: number;
  pending_items: ProcessedTaxItem[];
  cancellation_items: ProcessedTaxItem[];
  has_discrepancy: boolean;
}

export interface ProcessedBreakdownData {
  currencies: ProcessedTaxData[];
  is_empty: boolean;
  show_cancellation_section: boolean;
}

export interface TaxBreakdownConfig {
  title: string;
  subtitle: string;
  empty_message: string;
  pending_section_title: string;
  cancellation_section_title: string;
}

export interface UseTaxBreakdownModalProps {
  data?: TaxBreakdownResponse;
  type: TaxBreakdownType;
  context: TaxBreakdownContext;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  issuerName?: string;
}

export interface UseTaxBreakdownModalResult {
  processed_data: ProcessedBreakdownData;
  config: TaxBreakdownConfig;
  is_open: boolean;
  open_modal: () => void;
  close_modal: () => void;
}

export const TAX_CODE_ORDER = {
  transfers: {
    '001': 1, // ISR
    '002': 2, // IVA           
    '003': 3, // IEPS
  },
  withholdings: {
    '001': 1, // ISR
    '002': 2, // IVA           
    '003': 3, // IEPS
  }
} as const;

export const TAX_STATUS = {
  PENDING_LOADING: 'PENDING_LOADING',
  CANCELLATION_REQUESTED: 'CANCELLATION_REQUESTED',
} as const;

export const isValidTaxBreakdownType = (type: string): type is TaxBreakdownType => {
  return type === 'transfers' || type === 'withholdings';
};

export const isValidTaxBreakdownContext = (context: string): context is TaxBreakdownContext => {
  return context === 'general' || context === 'unregistered' || context === 'issuer';
};